import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from 'classnames';
import { getFontAwesomeIcon, hasValue, isFontawesomeIcon } from '../../../../utils';
import { UXPContext } from "@core/context/Context";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
function renderIcon(icon) {
    if (!hasValue(icon))
        return null;
    if (isFontawesomeIcon(icon)) {
        return _jsx("div", { className: "uxp-form-label__icon", children: _jsx(FontAwesomeIconWrapper, { icon: getFontAwesomeIcon(icon) }) });
    }
    return _jsx("div", { className: "uxp-form-label__icon", children: _jsx("div", { className: "uxp-form-label__icon-image", style: { backgroundImage: `url(${icon})` } }) });
}
/**
 * A simple label. Usually used in conjunction with a FormField
 * @export
 *
 * @example
 * ```
 * <Label>Name</Label>
 * ```
 */
const Label = (props) => {
    // props
    const context = React.useContext(UXPContext);
    const { labelFor, className, inline, styles } = props;
    // for
    let htmlFor = "";
    if (labelFor)
        htmlFor = labelFor;
    // return
    return (_jsxs("label", { htmlFor: htmlFor, className: classNames("uxpcore_form-label", className, {
            "uxpcore_form-label--inline": inline
        }), style: styles, children: [renderIcon(props.icon), props.children] }));
};
export default Label;
